import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, IconButton } from '@mui/material'
import { ReactNode } from 'react'

type ImageLightboxProps = {
  open: boolean
  onClose: () => void
  /** Accessible label for the close button. Passed in to keep this component i18n-agnostic. */
  closeLabel: string
  /** The full-size image to display, e.g. an `<img>` / `<Box component="img">`. */
  children: ReactNode
}

// Full-screen image preview: a transparent dialog over a dark backdrop with a
// fixed close button. Clicking anywhere outside the image (or the close button,
// backdrop, or Escape) dismisses it. The caller supplies the image element so
// it can own sizing and src lifecycle (e.g. data URIs vs. object URLs).
export const ImageLightbox = ({ open, onClose, closeLabel, children }: ImageLightboxProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
    slotProps={{ backdrop: { sx: { backgroundColor: 'rgba(0,0,0,0.8)' } } }}
    PaperProps={{
      onClick: onClose,
      sx: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        overflow: 'visible',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }}
  >
    <IconButton
      aria-label={closeLabel}
      onClick={(event) => {
        event.stopPropagation()
        onClose()
      }}
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 1,
        color: 'white',
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)' },
      }}
    >
      <CloseIcon fontSize="large" />
    </IconButton>
    <Box onClick={(event) => event.stopPropagation()} sx={{ display: 'flex' }}>
      {children}
    </Box>
  </Dialog>
)
